<div class="header">
  <a
    *ngIf="!hideBackUrl"
    class="header__link"
    [routerLink]="backUrl || defaultUrl"
    [queryParamsHandling]="queryParamsHandling"
  >
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </a>
  <span
    *ngIf="!hideBackButton"
    class="header__link"
    (click)="onBack.emit()"
  >
    <i class="fa fa-chevron-left" aria-hidden="true"></i>
  </span>
  <h4 class="header__text">{{text}}</h4>
  <div class="header__aside">
    <ng-content></ng-content>
  </div>
</div>
<h5 *ngIf="subtext" class="subtext">{{subtext}}</h5>
